import * as React from "react";
export function Cursor() {
    return <span className="blinking bold border-l"/>;
}
//# sourceMappingURL=cursor.jsx.map